import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M480-122.311q-24.077 0-42.577-12.692-18.499-12.692-25.884-33.308H400q-24.538 0-42.268-17.73-17.731-17.73-17.731-42.268v-131.23q-60.538-36.692-95.269-98.385Q210.001-519.616 210.001-590q0-112.922 78.538-191.461Q367.078-859.999 480-859.999q112.922 0 191.461 78.538Q749.999-702.922 749.999-590q0 71.615-34.731 132.692-34.731 61.077-95.269 97.769v131.23q0 24.538-17.731 42.268-17.73 17.73-42.268 17.73h-11.539q-7.385 20.616-25.884 33.308-18.5 12.692-42.577 12.692zm-80-105.998h160v-37.539H400v37.539zm0-72.923h160v-38.769H400v38.769zM392-400h64.154v-116.462l-85.692-85.692L404-635.692l76 76 76-76 33.538 33.538-85.692 85.692V-400H568q54-26 88-76.5T690-590q0-88-61-149t-149-61q-88 0-149 61t-61 149q0 63 34 113.5t88 76.5zm88-159.692zM480-600z"
      ></path>
    </svg>
  );
}

export default Icon;
